const topics = [
  { name: '#流浪地球3', heat: '1,256万讨论', icon: 'ri-fire-line' },
  { name: '#封神第二部', heat: '982万讨论', icon: 'ri-fire-line' },
  { name: '#奥本海默', heat: '874万讨论', icon: 'ri-flashlight-line' },
  { name: '#4K修复', heat: '763万讨论', icon: 'ri-4k-line' },
  { name: '#国产科幻', heat: '691万讨论', icon: 'ri-rocket-line' },
  { name: '#诺兰新片', heat: '625万讨论', icon: 'ri-movie-2-line' },
  { name: '#暑期档', heat: '558万讨论', icon: 'ri-sun-line' },
  { name: '#港片经典', heat: '487万讨论', icon: 'ri-vidicon-line' },
  { name: '#动漫剧场版', heat: '432万讨论', icon: 'ri-ghost-line' },
  { name: '#悬疑推荐', heat: '395万讨论', icon: 'ri-search-eye-line' },
  { name: '#IMAX体验', heat: '348万讨论', icon: 'ri-tv-2-line' },
];

export default function Topics() {
  return (
    <section id="topics" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100">热门话题</h2>
          <p className="text-foreground-500 text-sm mt-2">影迷圈正在热议的焦点话题</p>
        </div>
        <div className="flex flex-wrap gap-2 md:gap-3 justify-center">
          {topics.map((item) => (
            <div
              key={item.name}
              className="group flex items-center gap-2 px-4 py-2.5 bg-background-50 rounded-full border border-background-200/60 hover:border-primary-500/40 hover:bg-background-200/50 transition-all cursor-pointer"
            >
              <i className={`${item.icon} text-primary-400 text-sm`}></i>
              <span className="text-sm font-medium text-foreground-300 group-hover:text-foreground-100 transition-colors whitespace-nowrap">
                {item.name}
              </span>
              <span className="text-foreground-600 text-xs whitespace-nowrap">{item.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}